import React from 'react'

import {
  Page,
  H2,
  RuleList,
  Rule,
  Button,
} from '../styles'

const Rules = ({history}) => (
  <Page>
    <H2>How to Play</H2>

    <RuleList>
      <Rule>Have one player create a new game and send out the invite link so others can join. When all players have joined, the game creator should tap "start".</Rule>
      <Rule>When the game starts, you'll be assigned a word and another player as a target. Keep these secret!</Rule>
      <Rule>Kill your target by tricking them into saying the secret word out loud. It can take hours, days, or even weeks before they let their guard down.</Rule>
      <Rule>When you assassinate someone, immediately show them their name and word on your screen as proof that they're dead.</Rule>
      <Rule>If someone assassinates you, immediately mark yourself as "dead" in the app. Your assassin will be get your old target and word as their new assignment.</Rule>
      <Rule>Last one alive is the winner.</Rule>
    </RuleList>

    <H2>Homophones count</H2>
    <p>If a target says "Where to?" and their word is "two", they are dead.</p>

    <H2>Plurals count</H2>
    <p>If a target says "Nice shoes!" and their word is "shoe", they are dead.</p>

    <H2>Assassins are allowed say their target's word</H2>
    <p>If an assassin asks "Do you want coffee or tea?", the target says "coffee, please", and their word is "coffee", the target is dead.</p>

    <H2>Getting help is allowed</H2>
    <p>An assassin doesn't have to be the one to "make" their target say the word.</p>

    <H2>Accidents count</H2>
    <p>If a target says their word without anyone "making" them say it, they are dead.</p>

    <H2>Lying is allowed</H2>
    <p>You can lie about who your target is and what your secret word is. The only time you may NOT lie is when you tell people you killed them.</p>

    <br />

    <Button onClick={() => history.push('/')}>Back home</Button>

  </Page>
)

export default Rules



// WEBPACK FOOTER //
// ./src/views/lobby/Rules.jsx